<template>
  <v-list-item @click="detail(correction)">

    <v-list-item-title>
      {{ correction.BelegNr }}
    </v-list-item-title>
    <template #append>
      <v-list-item-action>
        <div>
          <v-chip class="mr-2" variant="outlined" size="x-small">{{ correction.Bediener }}</v-chip>
          <v-chip :color="correction.statusColor" variant="outlined">{{ correction.date }}</v-chip>
        </div>
      </v-list-item-action>
    </template>
  </v-list-item>
</template>

<script lang="ts">
import router from '@/router';
import {defineComponent} from 'vue';
import Correction, {ApiCorrection} from '@/model/Correction';
export default defineComponent({
  props: {
    correction: {
      type: Correction,
      required: true,
    },
  },
  setup() {
    return {
      detail(correction: ApiCorrection) {
        router.push({name: 'correction_create', params: {id: `${correction.BelegNr}`}}).catch(console.error);
      },
    };
  },
});
</script>
